import Vue from 'vue/dist/vue.esm';
import Vuex from 'vuex';
// import Buefy from 'buefy';
import {
  Button,
  Carousel,
  Checkbox,
  Dialog,
  Dropdown,
  Field,
  Icon,
  Input,
  Loading,
  Modal,
  Navbar,
  Notification,
  Numberinput,
  Progress,
  Radio,
  Switch,
  Tabs,
  Tag,
  Toast,
} from 'buefy'
import 'lazysizes';
import store from '@/store/store';
import VueToastPlugin from '@/plugins/toasts';
import VueHttpPlugin from '@/plugins/http';
import VueStoragePlugin from '@/plugins/storage';
import VueBuefyConfirmPlugin from '@/plugins/confirm';
import VuePopupWindowPlugin from '@/plugins/popup-window';
// import VueMomentPlugin from '@/plugins/moment';
import VueCurrencyFilter from 'vue-currency-filter';
// import VSwitch from 'v-switch-case'
import VueFilterTruncateStr from '@/plugins/filter-truncate';
import VueCookiesPlugin from '@/plugins/cookies';

// Import App-Wide components for reuse purposes.
import MediaImg from '@/components/media/MediaImg.vue';
import SimpleMediaImg from '@/components/media/SimpleMediaImg.vue';
import MediaCarousel from '@/components/media/MediaCarousel.vue';
import ProductsCarousel from '@/components/ProductsCarousel.vue';
import ImageMagnifier from '@/components/media/ImageMagnifier.vue';
import AddToCart from '@/components/AddToCart.vue';
import CartStatusBtn from '@/components/CartStatusBtn.vue';
import Cart from '@/components/Cart.vue';
import FillData from '@/components/FillData.vue';
import Confirmation from '@/components/Confirmation.vue';
import FreeShippingProgressBar from '@/components/FreeShippingProgressBar.vue';
import ModalPopupHandler from '@/components/ModalPopupHandler.vue';


import '@/assets/styles.scss';

Vue.use(Vuex);

// Vue.use(Buefy);

  Vue.use(Button);
  Vue.use(Carousel);
  Vue.use(Checkbox);
  Vue.use(Dialog);
  Vue.use(Dropdown);
  Vue.use(Field);
  Vue.use(Icon);
  Vue.use(Input);
  Vue.use(Loading);
  Vue.use(Modal);
  Vue.use(Notification);
  Vue.use(Navbar);
  Vue.use(Numberinput);
  Vue.use(Progress);
  Vue.use(Radio);
  Vue.use(Switch);
  Vue.use(Tabs);
  Vue.use(Tag);
  Vue.use(Toast);

Vue.use(VueToastPlugin);
Vue.use(VueHttpPlugin);
Vue.use(VueStoragePlugin);
Vue.use(VueBuefyConfirmPlugin);
Vue.use(VuePopupWindowPlugin);
// Vue.use(VueMomentPlugin);
Vue.use(VueCurrencyFilter, [
  {
    symbol: '$',
    thousandsSeparator: ',',
    fractionCount: 2,
    fractionSeparator: '.',
    symbolPosition: 'front',
    symbolSpacing: false,
    avoidEmptyDecimals: undefined,
  },

  {
    name: 'number',
    symbol: '',
    thousandsSeparator: ',',
    fractionCount: 0,
    fractionSeparator: '.',
    symbolPosition: 'front',
    symbolSpacing: false,
    avoidEmptyDecimals: undefined,
  },
]);

// Vue.use(VSwitch);
Vue.use(VueFilterTruncateStr);
Vue.use(VueCookiesPlugin);
Vue.component('MediaImg', MediaImg);
Vue.component('SimpleMediaImg', SimpleMediaImg);
Vue.component('MediaCarousel', MediaCarousel);
Vue.component('ImageMagnifier', ImageMagnifier);
Vue.component('AddToCart', AddToCart);
Vue.component('CartStatusBtn', CartStatusBtn);
Vue.component('Cart', Cart);
Vue.component('FillData', FillData);
Vue.component('Confirmation', Confirmation);
Vue.component('ProductsCarousel', ProductsCarousel);
Vue.component('FreeShippingProgressBar', FreeShippingProgressBar);
Vue.component('ModalPopupHandler', ModalPopupHandler);

Vue.config.productionTip = false;

new Vue({
  store: new Vuex.Store(store),
  el: '#app'
});
